import React, { useEffect } from "react";
import { colors, VStack } from "goi_common";
import HeroSection from "./compnents/HeroSection";
import BenefitSection from "./compnents/BenefitSection";

import AboutSection from "./compnents/AboutSection";
import ReviewSection from "./compnents/ReviewSection";
import NumberOneSection from "./compnents/NumberOneSection";
import CollaborationSection from "./compnents/CollaborationSection";
import PRSection from "./compnents/PRSection";
import Footer from "./compnents/Footer";
import LandingFixedButton from "@/components/common/LandingFixedButton";
import { useCustomVariation } from "@/hooks/useCustomVariation";
import useNoticeModal from "@/hooks/useNoticeModal";
import { LIVE_PRIME_PAY } from "@/constants/productKey";

export default function HomeV2Container() {
  const variation = useCustomVariation(37);
  const isVariationA = variation === "A";
  const { openModal } = useNoticeModal({ isToss: false });

  useEffect(() => {
    openModal();
  }, []);

  return (
    <VStack css={{ color: colors.white, overflowX: "hidden" }}>
      <HeroSection
        href={
          isVariationA
            ? "/registration/info/"
            : `/registration/verification/?productKey=${LIVE_PRIME_PAY.monthly}`
        }
      />

      <BenefitSection />
      <AboutSection />
      <ReviewSection />
      <NumberOneSection />
      <CollaborationSection />
      <PRSection />
      <Footer />
      <LandingFixedButton
        color={colors.gray900}
        text="100원 상조로 장례 준비하기"
        href={
          isVariationA
            ? "/registration/info/"
            : `/registration/verification/?productKey=${LIVE_PRIME_PAY.monthly}`
        }
      />
    </VStack>
  );
}
